export default "__VITE_ASSET__4a6434fc__"